<template>
  <div class="body">
    <h2>Links on Aging</h2>

<!--    <blockquote>-->
<!--      <p align="justify">Below are useful links related to basic aging research and <router-link href="/gerontology">gerontology</a>. Feel free to <A href="http://jp.senescence.info/contact.php">contact me</A> if you wish to suggest a link.</p></blockquote>-->

<!--    <hr width="80%" size="1">-->

<!--    <h3>Journals Related to the Biology of Aging</h3>-->
    <br>
    <b-list-group>
      <b-list-group-item variant="info">Journals Related to the Biology of Aging</b-list-group-item>
      <b-list-group-item href="http://www.springerlink.com/content/1574-4647/">Age</b-list-group-item>
      <b-list-group-item href="http://www.sciencedirect.com/science/journal/15681637">Ageing Research Reviews</b-list-group-item>
      <b-list-group-item href="http://www.impactaging.com/">AGING</b-list-group-item>
      <b-list-group-item href="http://www.aging-cell.com/">Aging Cell</b-list-group-item>
      <b-list-group-item href="http://www.sciencedirect.com/science/journal/01674943">Archives of Gerontology and Geriatrics</b-list-group-item>
      <b-list-group-item href="http://www.springerlink.com/content/1573-6768/">Biogerontology</b-list-group-item>
      <b-list-group-item href="http://www.sciencedirect.com/science/journal/05315565">Experimental Gerontology</b-list-group-item>
      <b-list-group-item href="http://www.karger.com/ger">Gerontology</b-list-group-item>
      <b-list-group-item href="https://academic.oup.com/gsa">GSA Journals</b-list-group-item>
      <b-list-group-item href="http://www.quantium.plus.com/lr/">Longevity Report</b-list-group-item>
      <b-list-group-item href="http://www.sciencedirect.com/science/journal/00476374">Mechanisms of Ageing and Development</b-list-group-item>
      <b-list-group-item href="http://www.sciencedirect.com/science/journal/01974580">Neurobiology of Aging</b-list-group-item>
      <b-list-group-item href="http://www.liebertpub.com/rej">Rejuvenation Research- formerly known as the Journal of Anti-Aging Medicine</b-list-group-item>
<br>
    </b-list-group>
    <b-list-group>
      <b-list-group-item variant="primary">Academic Research Centers</b-list-group-item>
      <b-list-group-item href="http://www.barshop.uthscsa.edu/">Barshop Institute</b-list-group-item>
      <b-list-group-item href="http://www.eriba.umcg.nl/">European Research Institute for the Biology of Ageing (ERIBA)</b-list-group-item>
      <b-list-group-item href="http://www.hcoa.org/">Huffington Center on Aging at Baylor College of Medicine</b-list-group-item>
      <b-list-group-item href="http://www.ncl.ac.uk/ageing/">Institute for Ageing at the University of Newcastle.</b-list-group-item>
      <b-list-group-item href="http://www.iba.oeaw.ac.at/">Institute for Biomedical Aging Research at the Austrian Academy of Sciences</b-list-group-item>
      <b-list-group-item href="http://www.liv.ac.uk/ageing-and-chronic-disease/">Institute of Ageing and Chronic Disease at the University of Liverpool.</b-list-group-item>
      <b-list-group-item href="http://www.iog.wayne.edu/">Institute of Gerontology at Wayne State University</b-list-group-item>
      <b-list-group-item href="https://www.ucl.ac.uk/biosciences/departments/genetics-evolution-and-environment/institute-healthy-ageing-iha">Institute of Healthy Ageing at University College London.</b-list-group-item>
      <b-list-group-item href="http://www.leibniz-fli.de/">Leibniz Institute on Aging</b-list-group-item>
      <b-list-group-item href="http://www.demogr.mpg.de/">Max Planck Institute for Demographic Research</b-list-group-item>
      <b-list-group-item href="http://www.age.mpg.de/">Max Planck Institute for Biology of Ageing</b-list-group-item>
      <b-list-group-item href="https://www.nia.nih.gov/">National Institute on Aging- not only they have their own laboratories but they are the major source of funding for aging research in the world; part of the US <a href="http://www.nih.gov/">National Institutes of Health</a></b-list-group-item>
      <b-list-group-item href="http://agingmice.jax.org/">The Aging Center at The Jackson Laboratory</b-list-group-item>
      <b-list-group-item href="http://www.buckinstitute.org/">The Buck Institute for Research on Aging</b-list-group-item>
      <b-list-group-item href="http://www.tmig.or.jp/">Tokyo Metropolitan Institute of Gerontology</b-list-group-item>
      <b-list-group-item href="http://www.med.umich.edu/geriatrics/index.htm">University of Michigan Geriatrics Center, including the <a href="http://www.med.umich.edu/geriatrics/research/IoG2.htm">Institute of Gerontology</a></b-list-group-item>

    </b-list-group>
    <br>

    <b-list-group>
      <b-list-group-item variant="success">Organizations of Interest</b-list-group-item>
      <b-list-group-item href="https://www.un.org/development/desa/ageing/">Ageing - Social Policy and Development Division from the United Nations.</b-list-group-item>
      <b-list-group-item href="http://www.americanaging.org">American Aging Association</b-list-group-item>
      <b-list-group-item href="http://www.afar.org/">American Federation for Aging Research</b-list-group-item>
      <b-list-group-item href="http://www.agingresearch.org/">Alliance for Aging Research</b-list-group-item>
      <b-list-group-item href="http://www.bg-rf.org.uk/">Biogerontology Research Foundation</b-list-group-item>
      <b-list-group-item href="http://www.bsra.org.uk/">British Society for Research on Ageing</b-list-group-item>
      <b-list-group-item href="http://www.ellisonfoundation.org/">Ellison Medical Foundation- founded by Oracle's CEO Larry Ellison, they provide grants for research on aging</b-list-group-item>
      <b-list-group-item href="http://www.geron.org/">Gerontological Society of America</b-list-group-item>
      <b-list-group-item href="http://glennfoundation.org/">Glenn Foundation for Medical Research</b-list-group-item>
      <b-list-group-item href="http://www.imminst.org">Immortality Institute and also check out their forum <a href="http://www.longecity.org/forum/">LongeCity</a></b-list-group-item>
      <b-list-group-item href="http://www.iagg.info/">International Association of Gerontology and Geriatrics</b-list-group-item>
      <b-list-group-item href="http://www.lef.org/">Life Extension Foundation</b-list-group-item>
      <b-list-group-item href="http://www.maxlife.org/">Maximum Life Foundation- they aim to facilitate investment in anti-aging research</b-list-group-item>
      <b-list-group-item href="http://www.mprize.org/">Methuselah Foundation</b-list-group-item>
      <b-list-group-item href="http://eng.scienceagainstaging.com/">Science for Life Extension Foundation</b-list-group-item>
      <b-list-group-item href="http://www.sens.org/">SENS Foundation</b-list-group-item>

    </b-list-group>
    <br>
    <b-list-group>
      <b-list-group-item variant="warning">Informational Websites</b-list-group-item>
      <b-list-group-item href="http://www.agelessanimals.org/">Ageless Animals</b-list-group-item>
      <b-list-group-item href="http://www.agingstats.gov/">AgingStats.Gov- aging-related statistics.</b-list-group-item>
      <b-list-group-item href="http://www.crsociety.org/">CR Society</b-list-group-item>
      <b-list-group-item href="http://www.fightaging.org/">Fight Aging! Excellent blog and advocacy for life-extension.</b-list-group-item>
      <b-list-group-item href="http://www.grg.org/">Gerontology Research Group</b-list-group-item>
      <b-list-group-item href="http://www.bsra.org.uk/">British Society for Research on Ageing</b-list-group-item>
      <b-list-group-item href="http://www.ellisonfoundation.org/">Ellison Medical Foundation- founded by Oracle's CEO Larry Ellison, they provide grants for research on aging</b-list-group-item>
      <b-list-group-item href="http://www.geron.org/">Gerontological Society of America</b-list-group-item>
      <b-list-group-item href="http://geroscience.com/">Geroscience</b-list-group-item>
      <b-list-group-item href="http://www.innovitaresearch.org/index.html">Innovita Research Foundation</b-list-group-item>
      <b-list-group-item href="http://ouroboros.wordpress.com/">Ouroboros- blog on the biology of aging</b-list-group-item>
      <b-list-group-item href="http://www.progeriaresearch.org/">Progeria Research Foundation</b-list-group-item>
      <b-list-group-item href="http://sageke.sciencemag.org">Science of Aging Knowledge Environment (SAGE KE) Archive Site- SAGE KE was an online journal associated with <a href="http://www.sciencemag.org">Science Magazine</a></b-list-group-item>
      <b-list-group-item href="http://www.mprize.org/">Methuselah Foundation</b-list-group-item>
      <b-list-group-item href="http://eng.scienceagainstaging.com/">Science for Life Extension Foundation</b-list-group-item>
      <b-list-group-item href="http://www.sens.org/">SENS Foundation</b-list-group-item>
    </b-list-group>

  </div>
</template>

<script>
import Footer from "./AppFooter";
export default {
  components: {Footer},
  methods: {
    goto(refName) {
      var element = this.$refs[refName];
      var top = element.offsetTop;

      window.scrollTo(0, top);
    }
  }
};
</script>
<style>
h2 {
  padding-top: 30px;
}
.body {
  margin-left: 10px;
  margin-right: 10px;
}
.sidebar {
  position: -webkit-sticky;
  position: sticky;
  top: 3%;
}

</style>



// WEBPACK FOOTER //
// src/components/Links.vue